// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".markdown{font-family:Consolas,Menlo,Bitstream Vera Sans Mono,Monaco,微软雅黑,monospace;font-size:13px}.markdown h1{font-size:18px;display:none}.markdown h2{font-size:16px;background-color:var(--el-color-primary-light-9);padding:10px 20px}", ""]);
// Exports
module.exports = exports;
